export default __webpack_public_path__ + "static/media/gender-male.78bef1ec.svg";